import { Box } from '@primer/react';
import React, { useEffect } from 'react';
import { RootState } from '../../state/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { actions } from '../../state/actions/actionsWrapper';
import { Bar, Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { useColors } from '../../hooks/useColors';
import Block from './Block';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const mainAction = actions.thongKe.crm;

const ThongKeCRMByNguonBietToi = () => {
    const { colors } = useColors();
    const { statusNguonBietToi, nguonBietTois } = useSelector((x: RootState) => x.thongKe.crm)
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(mainAction.LOAD_BY_NGUON_BIET_TOI_START({
            nam_hoc,
            dm_coso_id
        }))

    }, [nam_hoc, dm_coso_id])

    // Chuẩn bị dữ liệu cho Bar Chart
    const data = {
        labels: nguonBietTois.map(item => item.name), // Nhãn các môn học
        datasets: [
            {
                label: '',
                data: nguonBietTois.map(item => item.count), // Điểm tương ứng
                backgroundColor: nguonBietTois.map((t, idx) => {
                    return colors[idx % colors.length].hex;
                }),
                borderColor: nguonBietTois.map((t, idx) => {
                    return colors[idx % colors.length].hex;
                }),
                borderWidth: 1,
                barThickness: 20, // Độ dày của thanh Bar (pixel)
                maxBarThickness: 30, // Độ dày tối đa của mỗi Bar
                borderRadius: 4, // Bo tròn góc tha
            },
        ],
    };
    const options: any = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                display: false,
            },
            title: {
                display: false,
                text: 'Pie Chart Example',
            },
            datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 13,
                },
            },
        },
    };
    return (
        <Block>
            <Box sx={{ fontSize: 24, fontWeight: 600 }}>Thống kê theo nguồn biết tới</Box>
            <Box sx={{ fontSize: "1rem", color:"fg.muted" }}>Tổng số dữ liệu thu thập theo từng nguồn biết tới đã định nghĩa</Box>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 5
            }}>
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    // justifyContent: "center"
                }}>
                    <Box sx={{ height: "180px" }}>
                        <Pie data={data} options={options} />
                    </Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        {nguonBietTois.map((t, idx) => {
                            return <Box key={idx} sx={{
                                display: "flex",
                                mb: 2
                            }}>
                                <Box sx={{
                                    backgroundColor: colors[idx % colors.length].hex,
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "4px",
                                }}>&nbsp;</Box>
                                <Box sx={{
                                    ml: 2,
                                    fontWeight: "600",
                                    flex: 1,
                                    whiteSpace: "break-spaces"
                                }}>{t.name} : {t.count}</Box>
                            </Box>
                        })}
                    </Box>
                </Box>
            </Box>
        </Block>
    );
};

export default ThongKeCRMByNguonBietToi;